export const iconOptions = [
  // { label: 'Address Book', value: 'pi pi-address', type: 'general' },
  { label: 'Align Center', value: 'pi pi-align-center', type: 'formatting' },
  { label: 'Align Justify', value: 'pi pi-align-justify', type: 'formatting' },
  { label: 'Align Left', value: 'pi pi-align-left', type: 'formatting' },
  { label: 'Align Right', value: 'pi pi-align-right', type: 'formatting' },
  { label: 'Amazon', value: 'pi pi-amazon', type: 'brand' },
  { label: 'Android', value: 'pi pi-android', type: 'brand' },
  { label: 'Angle Double Down', value: 'pi pi-angle-double-down', type: 'navigation' },
  { label: 'Angle Double Left', value: 'pi pi-angle-double-left', type: 'navigation' },
  { label: 'Angle Double Right', value: 'pi pi-angle-double-right', type: 'navigation' },
  { label: 'Angle Double Up', value: 'pi pi-angle-double-up', type: 'navigation' },
  { label: 'Angle Down', value: 'pi pi-angle-down', type: 'navigation' },
  { label: 'Angle Left', value: 'pi pi-angle-left', type: 'navigation' },
  { label: 'Angle Right', value: 'pi pi-angle-right', type: 'navigation' },
  { label: 'Angle Up', value: 'pi pi-angle-up', type: 'navigation' },
  { label: 'Apple', value: 'pi pi-apple', type: 'brand' },
  { label: 'Arrow Circle Down', value: 'pi pi-arrow-circle-down', type: 'navigation' },
  { label: 'Arrow Circle Left', value: 'pi pi-arrow-circle-left', type: 'navigation' },
  { label: 'Arrow Circle Right', value: 'pi pi-arrow-circle-right', type: 'navigation' },
  { label: 'Arrow Circle Up', value: 'pi pi-arrow-circle-up', type: 'navigation' },
  { label: 'Arrow Down', value: 'pi pi-arrow-down', type: 'navigation' },
  { label: 'Arrow Down Left', value: 'pi pi-arrow-down-left', type: 'navigation' },
  // { label: 'Arrow Down Left and Up Right to Center', value: 'pi pi-arrow-down-left-and-arrow-up-right-to-center', type: 'navigation' },
  { label: 'Arrow Down Right', value: 'pi pi-arrow-down-right', type: 'navigation' },
  // { label: 'Arrow Left', value: 'pi pi-arrow-left', type: 'navigation' },
  // { label: 'Arrow Right', value: 'pi pi-arrow-right', type: 'navigation' },
  { label: 'Arrow Right Arrow Left', value: 'pi pi-arrow-right-arrow-left', type: 'navigation' },
  { label: 'Arrow Up', value: 'pi pi-arrow-up', type: 'navigation' },
  { label: 'Arrow Up Left', value: 'pi pi-arrow-up-left', type: 'navigation' },
  { label: 'Arrow Up Right', value: 'pi pi-arrow-up-right', type: 'navigation' },
  // { label: 'Arrow Up Right and Down Left from Center', value: 'pi pi-arrow-up-right-and-arrow-down-left-from-center', type: 'navigation' },
  { label: 'Arrows Alt', value: 'pi pi-arrows-alt', type: 'navigation' },
  { label: 'Arrows H', value: 'pi pi-arrows-h', type: 'navigation' },
  { label: 'Arrows V', value: 'pi pi-arrows-v', type: 'navigation' },
  // { label: 'Asterisk', value: 'pi pi-asterisk', type: 'general' },
  { label: 'At', value: 'pi pi-at', type: 'communication' },
  { label: 'Backward', value: 'pi pi-backward', type: 'media' },
  { label: 'Ban', value: 'pi pi-ban', type: 'status' },
  // { label: 'Barcode', value: 'pi pi-barcode', type: 'general' },
  { label: 'Bars', value: 'pi pi-bars', type: 'navigation' },
  { label: 'Bell', value: 'pi pi-bell', type: 'notification' },
  // { label: 'Bell Slash', value: 'pi pi-bell-slash', type: 'notification' },
  { label: 'Bitcoin', value: 'pi pi-bitcoin', type: 'currency' },
  { label: 'Bolt', value: 'pi pi-bolt', type: 'general' },
  { label: 'Book', value: 'pi pi-book', type: 'academic' },
  { label: 'Bookmark', value: 'pi pi-bookmark', type: 'general' },
  { label: 'Bookmark Fill', value: 'pi pi-bookmark-fill', type: 'general' },
  { label: 'Box', value: 'pi pi-box', type: 'general' },
  { label: 'Briefcase', value: 'pi pi-briefcase', type: 'business' },
  { label: 'Building', value: 'pi pi-building', type: 'location' },
  // { label: 'Building Columns', value: 'pi pi-building-columns', type: 'location' },
  // { label: 'Bullseye', value: 'pi pi-bullseye', type: 'general' },
  { label: 'Calculator', value: 'pi pi-calculator', type: 'tool' },
  { label: 'Calendar', value: 'pi pi-calendar', type: 'holiday' },
  // { label: 'Calendar Clock', value: 'pi pi-calendar-clock', type: 'holiday' },
  { label: 'Calendar Minus', value: 'pi pi-calendar-minus', type: 'holiday' },
  { label: 'Calendar Plus', value: 'pi pi-calendar-plus', type: 'holiday' },
  { label: 'Calendar Times', value: 'pi pi-calendar-times', type: 'holiday' },
  { label: 'Camera', value: 'pi pi-camera', type: 'media' },
  { label: 'Car', value: 'pi pi-car', type: 'transportation' },
  { label: 'Caret Down', value: 'pi pi-caret-down', type: 'navigation' },
  { label: 'Caret Left', value: 'pi pi-caret-left', type: 'navigation' },
  { label: 'Caret Right', value: 'pi pi-caret-right', type: 'navigation' },
  { label: 'Caret Up', value: 'pi pi-caret-up', type: 'navigation' },
  // { label: 'Cart Arrow Down', value: 'pi pi-cart-arrow-down', type: 'shopping' },
  // { label: 'Cart Minus', value: 'pi pi-cart-minus', type: 'shopping' },
  { label: 'Cart Plus', value: 'pi pi-cart-plus', type: 'shopping' },
  { label: 'Chart Bar', value: 'pi pi-chart-bar', type: 'data' },
  { label: 'Chart Line', value: 'pi pi-chart-line', type: 'data' },
  { label: 'Chart Pie', value: 'pi pi-chart-pie', type: 'data' },
  // { label: 'Chart Scatter', value: 'pi pi-chart-scatter', type: 'data' },
  { label: 'Check', value: 'pi pi-check', type: 'status' },
  { label: 'Check Circle', value: 'pi pi-check-circle', type: 'status' },
  { label: 'Check Square', value: 'pi pi-check-square', type: 'status' },
  { label: 'Chevron Circle Down', value: 'pi pi-chevron-circle-down', type: 'navigation' },
  { label: 'Chevron Circle Left', value: 'pi pi-chevron-circle-left', type: 'navigation' },
  { label: 'Chevron Circle Right', value: 'pi pi-chevron-circle-right', type: 'navigation' },
  { label: 'Chevron Circle Up', value: 'pi pi-chevron-circle-up', type: 'navigation' },
  { label: 'Chevron Down', value: 'pi pi-chevron-down', type: 'navigation' },
  { label: 'Chevron Left', value: 'pi pi-chevron-left', type: 'navigation' },
  { label: 'Chevron Right', value: 'pi pi-chevron-right', type: 'navigation' },
  { label: 'Chevron Up', value: 'pi pi-chevron-up', type: 'navigation' },
  { label: 'Circle', value: 'pi pi-circle', type: 'general' },
  { label: 'Circle Fill', value: 'pi pi-circle-fill', type: 'general' },
  // { label: 'Clipboard', value: 'pi pi-clipboard', type: 'tool' },
  { label: 'Clock', value: 'pi pi-clock', type: 'time' },
  { label: 'Clone', value: 'pi pi-clone', type: 'general' },
  { label: 'Cloud', value: 'pi pi-cloud', type: 'technology' },
  { label: 'Cloud Download', value: 'pi pi-cloud-download', type: 'technology' },
  { label: 'Cloud Upload', value: 'pi pi-cloud-upload', type: 'technology' },
  { label: 'Code', value: 'pi pi-code', type: 'development' },
  { label: 'Cog', value: 'pi pi-cog', type: 'settings' },
  { label: 'Comment', value: 'pi pi-comment', type: 'communication' },
  { label: 'Comments', value: 'pi pi-comments', type: 'communication' },
  { label: 'Compass', value: 'pi pi-compass', type: 'navigation' },
  { label: 'Copy', value: 'pi pi-copy', type: 'tool' },
  { label: 'Credit Card', value: 'pi pi-credit-card', type: 'payment' },
  // { label: 'Crown', value: 'pi pi-crown', type: 'general' },
  { label: 'Database', value: 'pi pi-database', type: 'technology' },
  { label: 'Delete Left', value: 'pi pi-delete-left', type: 'action' },
  { label: 'Desktop', value: 'pi pi-desktop', type: 'device' },
  { label: 'Directions', value: 'pi pi-directions', type: 'navigation' },
  { label: 'Directions Alt', value: 'pi pi-directions-alt', type: 'navigation' },
  { label: 'Discord', value: 'pi pi-discord', type: 'brand' },
  { label: 'Dollar', value: 'pi pi-dollar', type: 'currency' },
  { label: 'Download', value: 'pi pi-download', type: 'action' },
  { label: 'Eject', value: 'pi pi-eject', type: 'media' },
  { label: 'Ellipsis H', value: 'pi pi-ellipsis-h', type: 'navigation' },
  { label: 'Ellipsis V', value: 'pi pi-ellipsis-v', type: 'navigation' },
  { label: 'Envelope', value: 'pi pi-envelope', type: 'communication' },
  // { label: 'Equals', value: 'pi pi-equals', type: 'general' },
  { label: 'Eraser', value: 'pi pi-eraser', type: 'tool' },
  // { label: 'Ethereum', value: 'pi pi-ethereum', type: 'currency' },
  { label: 'Euro', value: 'pi pi-euro', type: 'currency' },
  { label: 'Exclamation Circle', value: 'pi pi-exclamation-circle', type: 'status' },
  { label: 'Exclamation Triangle', value: 'pi pi-exclamation-triangle', type: 'status' },
  // { label: 'Expand', value: 'pi pi-expand', type: 'action' },
  { label: 'External Link', value: 'pi pi-external-link', type: 'navigation' },
  { label: 'Eye', value: 'pi pi-eye', type: 'visibility' },
  { label: 'Eye Slash', value: 'pi pi-eye-slash', type: 'visibility' },
  // { label: 'Face Smile', value: 'pi pi-face-smile', type: 'emotion' },
  { label: 'Facebook', value: 'pi pi-facebook', type: 'brand' },
  { label: 'Fast Backward', value: 'pi pi-fast-backward', type: 'media' },
  { label: 'Fast Forward', value: 'pi pi-fast-forward', type: 'media' },
  { label: 'File', value: 'pi pi-file', type: 'document' },
  // { label: 'File Arrow Up', value: 'pi pi-file-arrow-up', type: 'document' },
  // { label: 'File Check', value: 'pi pi-file-check', type: 'document' },
  { label: 'File Edit', value: 'pi pi-file-edit', type: 'document' },
  { label: 'File Excel', value: 'pi pi-file-excel', type: 'document' },
  { label: 'File Export', value: 'pi pi-file-export', type: 'document' },
  { label: 'File Import', value: 'pi pi-file-import', type: 'document' },
  { label: 'File Pdf', value: 'pi pi-file-pdf', type: 'document' },
  // { label: 'File Plus', value: 'pi pi-file-plus', type: 'document' },
  { label: 'File Word', value: 'pi pi-file-word', type: 'document' },
  { label: 'Filter', value: 'pi pi-filter', type: 'tool' },
  { label: 'Filter Fill', value: 'pi pi-filter-fill', type: 'tool' },
  { label: 'Filter Slash', value: 'pi pi-filter-slash', type: 'tool' },
  { label: 'Flag', value: 'pi pi-flag', type: 'general' },
  { label: 'Flag Fill', value: 'pi pi-flag-fill', type: 'general' },
  { label: 'Folder', value: 'pi pi-folder', type: 'document' },
  { label: 'Folder Open', value: 'pi pi-folder-open', type: 'document' },
  // { label: 'Folder Plus', value: 'pi pi-folder-plus', type: 'document' },
  { label: 'Forward', value: 'pi pi-forward', type: 'media' },
  // { label: 'Gauge', value: 'pi pi-gauge', type: 'tool' },
  { label: 'Gift', value: 'pi pi-gift', type: 'general' },
  { label: 'Github', value: 'pi pi-github', type: 'brand' },
  { label: 'Globe', value: 'pi pi-globe', type: 'general' },
  { label: 'Google', value: 'pi pi-google', type: 'brand' },
  // { label: 'Graduation Cap', value: 'pi pi-graduation-cap', type: 'academic' },
  // { label: 'Hammer', value: 'pi pi-hammer', type: 'tool' },
  { label: 'Hashtag', value: 'pi pi-hashtag', type: 'communication' },
  // { label: 'Headphones', value: 'pi pi-headphones', type: 'media' },
  { label: 'Heart', value: 'pi pi-heart', type: 'athletics' },
  { label: 'Heart Fill', value: 'pi pi-heart-fill', type: 'athletics' },
  { label: 'History', value: 'pi pi-history', type: 'time' },
  { label: 'Home', value: 'pi pi-home', type: 'location' },
  { label: 'Hourglass', value: 'pi pi-hourglass', type: 'time' },
  { label: 'Id Card', value: 'pi pi-id-card', type: 'general' },
  { label: 'Image', value: 'pi pi-image', type: 'media' },
  { label: 'Images', value: 'pi pi-images', type: 'media' },
  { label: 'Inbox', value: 'pi pi-inbox', type: 'communication' },
  // { label: 'Indian Rupee', value: 'pi pi-indian-rupee', type: 'currency' },
  { label: 'Info', value: 'pi pi-info', type: 'status' },
  { label: 'Info Circle', value: 'pi pi-info-circle', type: 'status' },
  { label: 'Instagram', value: 'pi pi-instagram', type: 'brand' },
  { label: 'Key', value: 'pi pi-key', type: 'security' },
  { label: 'Language', value: 'pi pi-language', type: 'general' },
  // { label: 'Lightbulb', value: 'pi pi-lightbulb', type: 'general' },
  { label: 'Link', value: 'pi pi-link', type: 'communication' },
  { label: 'Linkedin', value: 'pi pi-linkedin', type: 'brand' },
  { label: 'List', value: 'pi pi-list', type: 'general' },
  // { label: 'List Check', value: 'pi pi-list-check', type: 'general' },
  { label: 'Lock', value: 'pi pi-lock', type: 'security' },
  { label: 'Lock Open', value: 'pi pi-lock-open', type: 'security' },
  { label: 'Map', value: 'pi pi-map', type: 'location' },
  { label: 'Map Marker', value: 'pi pi-map-marker', type: 'location' },
  // { label: 'Mars', value: 'pi pi-mars', type: 'general' },
  { label: 'Megaphone', value: 'pi pi-megaphone', type: 'communication' },
  // { label: 'Microchip', value: 'pi pi-microchip', type: 'technology' },
  // { label: 'Microchip AI', value: 'pi pi-microchip-ai', type: 'technology' },
  { label: 'Microphone', value: 'pi pi-microphone', type: 'media' },
  { label: 'Microsoft', value: 'pi pi-microsoft', type: 'brand' },
  { label: 'Minus', value: 'pi pi-minus', type: 'action' },
  { label: 'Minus Circle', value: 'pi pi-minus-circle', type: 'action' },
  { label: 'Mobile', value: 'pi pi-mobile', type: 'device' },
  { label: 'Money Bill', value: 'pi pi-money-bill', type: 'payment' },
  { label: 'Moon', value: 'pi pi-moon', type: 'general' },
  // { label: 'Objects Column', value: 'pi pi-objects-column', type: 'general' },
  { label: 'Palette', value: 'pi pi-palette', type: 'cultural' },
  { label: 'Paperclip', value: 'pi pi-paperclip', type: 'document' },
  { label: 'Pause', value: 'pi pi-pause', type: 'media' },
  // { label: 'Pause Circle', value: 'pi pi-pause-circle', type: 'media' },
  { label: 'Paypal', value: 'pi pi-paypal', type: 'brand' },
  // { label: 'Pen to Square', value: 'pi pi-pen-to-square', type: 'tool' },
  { label: 'Pencil', value: 'pi pi-pencil', type: 'tool' },
  { label: 'Percentage', value: 'pi pi-percentage', type: 'general' },
  { label: 'Phone', value: 'pi pi-phone', type: 'communication' },
  // { label: 'Pinterest', value: 'pi pi-pinterest', type: 'brand' },
  { label: 'Play', value: 'pi pi-play', type: 'media' },
  // { label: 'Play Circle', value: 'pi pi-play-circle', type: 'media' },
  { label: 'Plus', value: 'pi pi-plus', type: 'action' },
  { label: 'Plus Circle', value: 'pi pi-plus-circle', type: 'action' },
  { label: 'Pound', value: 'pi pi-pound', type: 'currency' },
  { label: 'Power Off', value: 'pi pi-power-off', type: 'action' },
  { label: 'Prime', value: 'pi pi-prime', type: 'brand' },
  { label: 'Print', value: 'pi pi-print', type: 'action' },
  { label: 'Qrcode', value: 'pi pi-qrcode', type: 'general' },
  { label: 'Question', value: 'pi pi-question', type: 'status' },
  { label: 'Question Circle', value: 'pi pi-question-circle', type: 'status' },
  // { label: 'Receipt', value: 'pi pi-receipt', type: 'document' },
  { label: 'Reddit', value: 'pi pi-reddit', type: 'brand' },
  { label: 'Refresh', value: 'pi pi-refresh', type: 'action' },
  { label: 'Replay', value: 'pi pi-replay', type: 'media' },
  { label: 'Reply', value: 'pi pi-reply', type: 'communication' },
  { label: 'Save', value: 'pi pi-save', type: 'action' },
  { label: 'Search', value: 'pi pi-search', type: 'tool' },
  { label: 'Search Minus', value: 'pi pi-search-minus', type: 'tool' },
  { label: 'Search Plus', value: 'pi pi-search-plus', type: 'tool' },
  { label: 'Send', value: 'pi pi-send', type: 'communication' },
  { label: 'Server', value: 'pi pi-server', type: 'technology' },
  { label: 'Share Alt', value: 'pi pi-share-alt', type: 'communication' },
  { label: 'Shield', value: 'pi pi-shield', type: 'security' },
  // { label: 'Shop', value: 'pi pi-shop', type: 'shopping' },
  { label: 'Shopping Bag', value: 'pi pi-shopping-bag', type: 'shopping' },
  { label: 'Shopping Cart', value: 'pi pi-shopping-cart', type: 'shopping' },
  { label: 'Sign In', value: 'pi pi-sign-in', type: 'authentication' },
  { label: 'Sign Out', value: 'pi pi-sign-out', type: 'authentication' },
  { label: 'Sitemap', value: 'pi pi-sitemap', type: 'general' },
  { label: 'Slack', value: 'pi pi-slack', type: 'brand' },
  { label: 'Sliders H', value: 'pi pi-sliders-h', type: 'tool' },
  { label: 'Sliders V', value: 'pi pi-sliders-v', type: 'tool' },
  { label: 'Sort', value: 'pi pi-sort', type: 'sorting' },
  { label: 'Sort Alpha Down', value: 'pi pi-sort-alpha-down', type: 'sorting' },
  { label: 'Sort Alpha Down Alt', value: 'pi pi-sort-alpha-down-alt', type: 'sorting' },
  { label: 'Sort Alpha Up', value: 'pi pi-sort-alpha-up', type: 'sorting' },
  { label: 'Sort Alpha Up Alt', value: 'pi pi-sort-alpha-up-alt', type: 'sorting' },
  { label: 'Sort Alt', value: 'pi pi-sort-alt', type: 'sorting' },
  { label: 'Sort Alt Slash', value: 'pi pi-sort-alt-slash', type: 'sorting' },
  { label: 'Sort Amount Down', value: 'pi pi-sort-amount-down', type: 'sorting' },
  { label: 'Sort Amount Down Alt', value: 'pi pi-sort-amount-down-alt', type: 'sorting' },
  { label: 'Sort Amount Up', value: 'pi pi-sort-amount-up', type: 'sorting' },
  { label: 'Sort Amount Up Alt', value: 'pi pi-sort-amount-up-alt', type: 'sorting' },
  { label: 'Sort Down', value: 'pi pi-sort-down', type: 'sorting' },
  // { label: 'Sort Down Fill', value: 'pi pi-sort-down-fill', type: 'sorting' },
  { label: 'Sort Numeric Down', value: 'pi pi-sort-numeric-down', type: 'sorting' },
  { label: 'Sort Numeric Down Alt', value: 'pi pi-sort-numeric-down-alt', type: 'sorting' },
  { label: 'Sort Numeric Up', value: 'pi pi-sort-numeric-up', type: 'sorting' },
  { label: 'Sort Numeric Up Alt', value: 'pi pi-sort-numeric-up-alt', type: 'sorting' },
  { label: 'Sort Up', value: 'pi pi-sort-up', type: 'sorting' },
  // { label: 'Sort Up Fill', value: 'pi pi-sort-up-fill', type: 'sorting' },
  // { label: 'Sparkles', value: 'pi pi-sparkles', type: 'general' },
  { label: 'Spinner', value: 'pi pi-spinner', type: 'status' },
  // { label: 'Spinner Dotted', value: 'pi pi-spinner-dotted', type: 'status' },
  { label: 'Star', value: 'pi pi-star', type: 'recreational' },
  { label: 'Star Fill', value: 'pi pi-star-fill', type: 'recreational' },
  // { label: 'Star Half', value: 'pi pi-star-half', type: 'general' },
  // { label: 'Star Half Fill', value: 'pi pi-star-half-fill', type: 'general' },
  { label: 'Step Backward', value: 'pi pi-step-backward', type: 'media' },
  { label: 'Step Backward Alt', value: 'pi pi-step-backward-alt', type: 'media' },
  { label: 'Step Forward', value: 'pi pi-step-forward', type: 'media' },
  { label: 'Step Forward Alt', value: 'pi pi-step-forward-alt', type: 'media' },
  { label: 'Stop', value: 'pi pi-stop', type: 'media' },
  { label: 'Stop Circle', value: 'pi pi-stop-circle', type: 'media' },
  { label: 'Stopwatch', value: 'pi pi-stopwatch', type: 'time' },
  { label: 'Sun', value: 'pi pi-sun', type: 'general' },
  { label: 'Sync', value: 'pi pi-sync', type: 'action' },
  { label: 'Table', value: 'pi pi-table', type: 'data' },
  { label: 'Tablet', value: 'pi pi-tablet', type: 'device' },
  { label: 'Tag', value: 'pi pi-tag', type: 'general' },
  { label: 'Tags', value: 'pi pi-tags', type: 'general' },
  { label: 'Telegram', value: 'pi pi-telegram', type: 'brand' },
  { label: 'Th Large', value: 'pi pi-th-large', type: 'layout' },
  { label: 'Thumbs Down', value: 'pi pi-thumbs-down', type: 'emotion' },
  { label: 'Thumbs Down Fill', value: 'pi pi-thumbs-down-fill', type: 'emotion' },
  { label: 'Thumbs Up', value: 'pi pi-thumbs-up', type: 'emotion' },
  { label: 'Thumbs Up Fill', value: 'pi pi-thumbs-up-fill', type: 'emotion' },
  // { label: 'Thumbtack', value: 'pi pi-thumbtack', type: 'general' },
  { label: 'Ticket', value: 'pi pi-ticket', type: 'general' },
  // { label: 'Tiktok', value: 'pi pi-tiktok', type: 'brand' },
  { label: 'Times', value: 'pi pi-times', type: 'action' },
  { label: 'Times Circle', value: 'pi pi-times-circle', type: 'action' },
  { label: 'Trash', value: 'pi pi-trash', type: 'action' },
  // { label: 'Trophy', value: 'pi pi-trophy', type: 'athletics' },
  { label: 'Truck', value: 'pi pi-truck', type: 'excursion' },
  // { label: 'Turkish Lira', value: 'pi pi-turkish-lira', type: 'currency' },
  // { label: 'Twitch', value: 'pi pi-twitch', type: 'brand' },
  { label: 'Twitter', value: 'pi pi-twitter', type: 'brand' },
  { label: 'Undo', value: 'pi pi-undo', type: 'action' },
  { label: 'Unlock', value: 'pi pi-unlock', type: 'security' },
  { label: 'Upload', value: 'pi pi-upload', type: 'action' },
  { label: 'User', value: 'pi pi-user', type: 'user' },
  { label: 'User Edit', value: 'pi pi-user-edit', type: 'user' },
  { label: 'User Minus', value: 'pi pi-user-minus', type: 'user' },
  { label: 'User Plus', value: 'pi pi-user-plus', type: 'user' },
  { label: 'Users', value: 'pi pi-users', type: 'social_event' },
  // { label: 'Venus', value: 'pi pi-venus', type: 'general' },
  { label: 'Verified', value: 'pi pi-verified', type: 'status' },
  { label: 'Video', value: 'pi pi-video', type: 'media' },
  { label: 'Vimeo', value: 'pi pi-vimeo', type: 'brand' },
  { label: 'Volume Down', value: 'pi pi-volume-down', type: 'media' },
  { label: 'Volume Off', value: 'pi pi-volume-off', type: 'media' },
  { label: 'Volume Up', value: 'pi pi-volume-up', type: 'media' },
  { label: 'Wallet', value: 'pi pi-wallet', type: 'payment' },
  // { label: 'Warehouse', value: 'pi pi-warehouse', type: 'location' },
  // { label: 'Wave Pulse', value: 'pi pi-wave-pulse', type: 'general' },
  { label: 'Whatsapp', value: 'pi pi-whatsapp', type: 'brand' },
  { label: 'Wifi', value: 'pi pi-wifi', type: 'technology' },
  { label: 'Window Maximize', value: 'pi pi-window-maximize', type: 'window' },
  { label: 'Window Minimize', value: 'pi pi-window-minimize', type: 'window' },
  { label: 'Wrench', value: 'pi pi-wrench', type: 'tool' },
  { label: 'Youtube', value: 'pi pi-youtube', type: 'brand' },
  { label: 'Bicycle', value: 'fa fa-bicycle', type: 'solid' },
  { label: 'Football', value: 'fa fa-futbol', type: 'solid' },
  { label: 'Graduation Cap', value: 'fa fa-graduation-cap', type: 'solid' },
  { label: 'Champagne Glasses', value: 'fa fa-champagne-glasses', type: 'solid' },
];